import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  Container,
  Paragraph,
  Divider,
  Button,
  CloseButton,
  Icon
} from "./Styles";
import ModalActions from "../../redux/reducers/modal.reducer";
import InvestmentCancellationAction from "../../redux/reducers/investment-cancellation.reducer";
import AnalyticsActions from "../../redux/reducers/analytics.reducer";
import AnalyticsModel from "../../lib/models/analytics.model";

const MoneyWithdrawalModal = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const startMoneyWithdrawalFlow = (userData) => {
    dispatch(ModalActions.setConditionalModalState(false));
    dispatch(
      InvestmentCancellationAction.otpRequestWithRedirect(userData.user_id)
    );
    dispatch(AnalyticsActions.trackEvent(AnalyticsModel.goToCancelSure));
  };

  return (
    <Container id="moneyWithdrawalPopUp">
      <CloseButton
        id="back-button"
        onClick={() => dispatch(ModalActions.setConditionalModalState(false))}
      >
        <Icon alt="previous" src="/assets/images/close_2.png" />
      </CloseButton>
      <Paragraph>
        <b>{t("moneyWithdrawalModal.question")}</b>
      </Paragraph>
      <Paragraph>{`${t("moneyWithdrawalModal.text")}`}</Paragraph>
      <Divider />
      <Button
        id="continue-button"
        onClick={() => startMoneyWithdrawalFlow(props)}
      >
        {t("moneyWithdrawalModal.sure")}
      </Button>
    </Container>
  );
};

export default MoneyWithdrawalModal;
